export default "__VITE_ASSET__8ff4f425__"